import { createContext, useContext } from 'react'
import { EMPTY_TICKET_LOOKUPS, TicketLookupMaps } from './ticketLookups'

const TicketLookupsContext = createContext<TicketLookupMaps>(EMPTY_TICKET_LOOKUPS)

export function TicketLookupsProvider({
  lookups,
  children,
}: {
  lookups: TicketLookupMaps
  children: React.ReactNode
}) {
  return <TicketLookupsContext.Provider value={lookups}>{children}</TicketLookupsContext.Provider>
}

export function useTicketLookupMaps(): TicketLookupMaps {
  return useContext(TicketLookupsContext)
}
